var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0013C16 14.1604 17.4924 12.668 19.3333 12.668C21.1743 12.668 22.6667 14.1604 22.6667 16.0013C22.6667 17.8423 21.1743 19.3346 19.3333 19.3346C17.4924 19.3346 16 17.8423 16 16.0013Z",
    fill: "#1ABCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33337 22.6654C9.33337 20.8244 10.8258 19.332 12.6667 19.332H16V22.6654C16 24.5063 14.5077 25.9987 12.6667 25.9987C10.8258 25.9987 9.33337 24.5063 9.33337 22.6654Z",
    fill: "#0ACF83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6V12.6667H19.3333C21.1743 12.6667 22.6667 11.1743 22.6667 9.33333C22.6667 7.49238 21.1743 6 19.3333 6H16Z",
    fill: "#FF7262"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33337 9.33333C9.33337 11.1743 10.8258 12.6667 12.6667 12.6667H16V6H12.6667C10.8258 6 9.33337 7.49238 9.33337 9.33333Z",
    fill: "#F24E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33337 16.0013C9.33337 17.8423 10.8258 19.3346 12.6667 19.3346H16V12.668H12.6667C10.8258 12.668 9.33337 14.1604 9.33337 16.0013Z",
    fill: "#A259FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.40ae13031586c7c2f44b57bea445103a.svg";
export { ForwardRef as ReactComponent };